import { render } from "./AllVideosWall.vue?vue&type=template&id=0dec1ba9&scoped=true"
import script from "./AllVideosWall.vue?vue&type=script&lang=js"
export * from "./AllVideosWall.vue?vue&type=script&lang=js"

import "./AllVideosWall.vue?vue&type=style&index=0&id=0dec1ba9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec1ba9"]])

export default __exports__